import { useToolSinglePageContext } from "@/helpers/contexts/ToolSinglePageContext";
import dynamic from "next/dynamic";

const AlphabetizerTool = dynamic(() => import("../../tools/alphabetizer/tool/AlphabetizerTool"));
const AssignmentCalendarTool = dynamic(
  () => import("../../tools/assignment-calendar/AssignmentCalendarTool")
);
const SectionConclusionGenTool = dynamic(
  () => import("../../tools/conclusion-generator/SectionConclusionGenTool")
);
const ThesisStatementGenerator = dynamic(
  () => import("../../tools/thesis-statement-generator/tool/ThesisStatementGenerator")
);

const GradeCalculatorTool = dynamic(() => import("../../tools/grade-calculator/tool/GradeCalculatorTool"));

const CaseConverterTool = dynamic(() => import("../../tools/case-converter/CaseConverterTool"));

const GrammarCheckerTool = dynamic(() => import("../../tools/grammar-checker/tool/GrammarCheckerTool"));

const PlagiarismCheckerTool = dynamic(() => import("../../tools/plagiarism-checker/PlagiarismCheckerTool"));

const SummarizerTool = dynamic(() => import("../../tools/summarizer/SummarizerTool"));

const ParaphrasingTool = dynamic(() => import("../../tools/paraphrasing/ParaphrasingTool"));

const WordCounterTool = dynamic(() => import("../../tools/word-counter/WordCounterTool"));

const ReadabilityCheckerTool = dynamic(
  () => import("../../tools/readability-checker/tool/ReadabilityCheckerTool")
);

const EssayMakerTool = dynamic(() => import("../../tools/essay-maker/tool/EssayMakerTool"));

const EssayTyperTool = dynamic(() => import("../../tools/essay-typer/tool/EssayTyperTool"));

const PaperGraderTool = dynamic(() => import("../../tools/paper-grader/tool/PaperGraderTool"));

const SpellCheckerTool = dynamic(() => import("../../tools/spell-checker/tool/SpellCheckerTool"));

const EssayTitleGenerator = dynamic(
  () => import("../../tools/essay-title-generator/tool/EssayTitleGenerator")
);

const SectionTitlePageGenTool = dynamic(
  () => import("../../tools/title-page-generator/SectionTitlePageGenTool")
);

const WordsToPagesTool = dynamic(() => import("../../tools/words-to-pages/WordsToPagesTool"));

type CurrentToolProps = {
  tool: string;
};

export const CurrentTool = ({ tool }: CurrentToolProps) => {
  const data = useToolSinglePageContext();
  if (!data) return null;
  const { subjects } = data;

  //TODO: Fields for Words to pages converter (temporary)
  const fields = {
    maxWords: 1000000000,
    minWords: 100,
    fontSizes: [
      { id: 1, value: 1, name: "12pt" },
      { id: 1.1, value: 1.1, name: "14pt" },
      { id: 1.2, value: 1.2, name: "16pt" },
      { id: 1.3, value: 1.3, name: "18pt" },
    ],
    fonts: [
      { id: 1, value: 1, name: "Times New Roman" },
      { id: 1.3, value: 1.3, name: "Calibri" },
      { id: 1.09, value: 1.09, name: "Cambria" },
      { id: 1.5, value: 1.5, name: "Georgia" },
      { id: 0.8, value: 0.8, name: "Arial" },
      { id: 0.9, value: 0.9, name: "Comic Sans MS" },
      { id: 0.79, value: 0.79, name: "Verdana" },
      { id: 1.1, value: 1.1, name: "Myriad Pro" },
      { id: 1.2, value: 1.2, name: "Open Sans" },
    ],
    spacings: [
      { id: 600, value: 600, name: "Single" },
      { id: 450, value: 450, name: "1.5" },
      { id: 300, value: 300, name: "Double-spaced" },
    ],
  };

  switch (tool) {
    case "alphabetizer":
      return <AlphabetizerTool />;
    case "assignment-calendar":
      return <AssignmentCalendarTool />;
    case "conclusion-generator":
      return <SectionConclusionGenTool />;
    case "thesis-statement-generator":
      return <ThesisStatementGenerator />;
    case "grade-calculator":
      return <GradeCalculatorTool />;
    case "case-converter":
      return <CaseConverterTool />;
    case "grammar-checker":
      return <GrammarCheckerTool />;
    case "plagiarism-checker":
      return <PlagiarismCheckerTool />;
    case "summarizer":
      return <SummarizerTool />;
    case "paraphrasing-tool":
      return <ParaphrasingTool />;
    case "word-counter":
      return <WordCounterTool />;
    case "readability-checker":
      return <ReadabilityCheckerTool />;
    case "essay-maker":
      return <EssayMakerTool />;
    case "essay-typer":
      return <EssayTyperTool />;
    case "free-paper-grader":
      return <PaperGraderTool />;
    case "spell-checker":
      return <SpellCheckerTool />;
    case "essay-title-generator":
      return <EssayTitleGenerator subjects={subjects} />;
    case "title-page-generator":
      return <SectionTitlePageGenTool />;
    case "words-to-pages-converter":
      return <WordsToPagesTool fields={fields} />;
    default:
      return null;
  }
};
